import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import BlogImg1 from '../../assets/images/artwer/project-2-antislip-apeldoorn-card.jpg';
import BlogImg2 from '../../assets/images/artwer/project-4-hemelwater-bussum-card.jpg';
import BlogImg3 from '../../assets/images/artwer/project-5-buitentrap-nijverdal-card.jpg';

const swiperOptions = {
  modules: [Autoplay, Pagination, Navigation],
  slidesPerView: 3,
  spaceBetween: 30,
  speed: 2000,
  autoplay: { delay: 9000, disableOnInteraction: false },
  loop: false,
  navigation: { nextEl: '.swiper-button-next1', prevEl: '.swiper-button-prev1' },
  pagination: { el: '.swiper-dot-style1', type: 'bullets', clickable: true },
  breakpoints: {
    0: { spaceBetween: 0, slidesPerView: 1 },
    575: { spaceBetween: 0, slidesPerView: 1 },
    768: { spaceBetween: 30, slidesPerView: 2 },
    992: { spaceBetween: 30, slidesPerView: 2 },
    1200: { spaceBetween: 30, slidesPerView: 3 },
  },
};

// Placeholder kennisartikelen — kunnen later worden uitgebreid.
const blogItems = [
  {
    id: 1,
    image: BlogImg1,
    date: 'Tip',
    title: 'Wanneer is balkonrenovatie écht nodig?',
  },
  {
    id: 2,
    image: BlogImg2,
    date: 'Onderhoud',
    title: 'Plan balkon- en galerijonderhoud op tijd',
  },
  {
    id: 3,
    image: BlogImg3,
    date: 'Techniek',
    title: 'Soprema ALSAN® PMMA: waterdicht, snel en duurzaam',
  },
];

export default function BlogTwo() {
  return (
    <>
      <section className="blog-two">
        <div className="container">
          <div className="section-title text-left">
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">Tips &amp; advies</span>
            </div>
            <h2 className="section-title__title">
              Kennis &amp; <span>tips</span>
            </h2>
          </div>
          <Swiper {...swiperOptions} className="blog-two__carousel">
            {blogItems.map(item => (
              <SwiperSlide key={item.id}>
                <div className="blog-two__single">
                  <div className="blog-two__img-box">
                    <div className="blog-two__img">
                      <img src={item.image} alt={item.title} loading="lazy" />
                      <div className="blog-two__date">
                        <p>{item.date}</p>
                      </div>
                    </div>
                  </div>
                  <div className="blog-two__content">
                    <ul className="blog-two__meta list-unstyled">
                      <li>
                        <a href="#contact"><span className="icon-user"></span><span className="nowrap">ART-WER</span></a>
                      </li>
                      <li>
                        <a href="#contact"><span className="icon-callender"></span>Advies &amp; tips</a>
                      </li>
                    </ul>
                    <h3 className="blog-two__title">
                      <a href="#contact">{item.title}</a>
                    </h3>
                    <div className="blog-two__btn-box">
                      <a href="#contact" className="blog-two__btn" aria-label={`Vraag advies over: ${item.title}`}>
                        Vraag advies<span className="icon-dubble-arrow-right"></span>
                      </a>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
    </>
  );
}
